import { Component, ElementRef, Input, OnInit } from '@angular/core';
import * as echarts from "echarts";

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss']
})
export class ChartComponent implements OnInit {

  @Input() collegeWiseAgeOfEarning=[];
  @Input() college4YearExpense=[];
  @Input() title:string='';
  @Input() type:string='';
  lineChart: any;
  showChart=false;
  xAxis: any;
  range: any;
  constructor(private elm: ElementRef) { }

  ngOnInit(): void {

    if(this.type=="AgeWiseEarning")
    {
      if((this.collegeWiseAgeOfEarning[0]?.xAxis.length>0) && (this.collegeWiseAgeOfEarning[0]))
      {
        this.setDataInChart();
      }
    }
    if(this.type=="4YearExpensesTimeLine")
    {
      if((this.college4YearExpense[0]?.xAxis.length>0) && (this.college4YearExpense[0]))
      {
        this.set4yearExpensesDataInChart()
      }
      
    }
   
   
  }

  setDataInChart(){
    this.lineChart=[];
   
    this.lineChart = echarts.init($(this.elm.nativeElement).find('#lineChart')[0]);
    const _this = this;
    let univName =[];
    let seriesData = [];
    this.lineChart.clear();
    this.collegeWiseAgeOfEarning[0].universityList.forEach(elem=>{

      if(elem?.universityName && elem?.yAxis.length>0)
      {
      const data ={
        data: elem.yAxis,
        type: 'bar',  
		    name: elem.universityName, 
      }
      seriesData.push(data);
      univName.push(elem.universityName)
    }
    })

    this.lineChart.setOption({
      legend: {
        data: univName
      },
      tooltip: {
        trigger: 'item',
        axisPointer: {
          label: {
            backgroundColor: '#6a7985'
          }
        },
        formatter: function (params, ticket, callback) { 
          return `<b>${_this.formatAxixCurrencyRounOF(params.value)} </b> ${params.seriesName}`;
          // return `<b>${params.name} </b> ${params.seriesName}(${_this.formatAxixCurrencyRounOF(params.value)})`;
      }},
      xAxis: {
        type: 'category',
        data: this.collegeWiseAgeOfEarning[0].xAxis,
        name: 'Age Group',
        nameLocation: 'middle',
        nameTextStyle: {
          align: "center",
          padding: [15, 0, 0, 0],
          fontWeight: "bold",
          fontSize: 14
        },
      },
      yAxis: {
        type: 'value',
        name: 'Estimated Earnings',
        nameLocation: 'middle',
        nameGap: 32,
        nameTextStyle: {
          align: "center",
          padding: [0, 0, 22, 0],
          fontWeight: "bold",
          verticalAlign: "bottom",
          fontSize: 14
        } ,
        // min: (Math.min.apply(null, dattaArr) - Math.min.apply(null, dattaArr) * 25 / 100),
        axisLabel: {
          formatter: function (value, index) { 
              return ` ${_this.formatAxixCurrencyRounOF(value)}`;
          }
        }

      },
      series: seriesData
    })

    this.showChart=true;
  }


  set4yearExpensesDataInChart(){
   
    this.lineChart = echarts.init($(this.elm.nativeElement).find('#lineChart')[0]);
    const _this = this;
    let univName =[];
    let seriesData = [];
    this.college4YearExpense[0].universityList.forEach((elem,index)=>{
     
      const timeLinedata1 ={
        data: elem.yAxislifetimeROI,
        type: 'bar',  
		    name: "Lifetime return on investment(ROI)", 
      
      }
      seriesData.push(timeLinedata1);

      const timeLinedata ={
        data: elem.yAxis4YearTotalExpenditure,
        type: 'bar',  
		    name: "4 Years Total Expenses", 
      }
      seriesData.push(timeLinedata);
    })

    // this.college4YearExpense[0].universityList.forEach(elem=>{
      
    // })
    this.lineChart.setOption({
      legend: {
        data: ["Lifetime return on investment(ROI)","4 Years Total Expenses"],
      },
      tooltip: {
        trigger: 'item',
        axisPointer: {
          label: {
            backgroundColor: '#6a7985'
          }
        },
        formatter: function (params, ticket, callback) { 
          return `<b>${_this.formatAxixCurrencyRounOF(params.value)} </b> ${params.seriesName}`;
      }},
      xAxis: {
        type: 'category',
        axisLabel: {
          rotate: 10,
          // overflow: 'break',
          // width: 80
        },
        data: this.college4YearExpense[0].xAxis,
        name: 'Institution Name',
        nameLocation: 'middle',
        nameTextStyle: {
          align: "center",
          padding: [50, 0, 0, 0],
          fontWeight: "bold",
          fontSize: 14,
         
        },
      }, 
      grid: {
        bottom: '100'
      },
      yAxis: {
        type: 'value',
        name: 'Lifetime (ROI) & 4 years Total Expenses',
        nameLocation: 'middle',
        nameGap: 32,
        nameTextStyle: {
          align: "center",
          padding: [0, 0, 22, 0],
          fontWeight: "bold",
          verticalAlign: "bottom",
          fontSize: 14
        } ,
        // min: (Math.min.apply(null, dattaArr) - Math.min.apply(null, dattaArr) * 25 / 100),
        axisLabel: {
          formatter: function (value, index) { 
              return ` ${_this.formatAxixCurrencyRounOF(value)}`;
          }
        }

      },
      series: seriesData
    })
    this.showChart=true;
  }
  
  formatAxixCurrencyRounOF(cur: number) {
    const num = Math.abs(cur) > 999 ? ((Math.abs(cur) / 1000).toFixed(0)) + 'k' : Math.abs(cur)
    return '$' + num
  }


  ngOnChanges()
  {
    if(this.type=="AgeWiseEarning")
    {
      if((this.collegeWiseAgeOfEarning[0]?.xAxis.length>0) && (this.collegeWiseAgeOfEarning[0]))
      {
        this.setDataInChart();
      }
    }
  }

}
